import { Spinner } from "components/Spinner/Spinner"

/**
 * Shows faint spinner centered in the page
 */
export const SpinnerPage = () => (
  <div className="flex min-h-[200px] w-full flex-col items-center justify-center">
    <Spinner variant="default" className="opacity-70" />
  </div>
)
